import { useNavigate } from "react-router";

function NavBtn({ children, onClick, className }: { children: string; onClick?: () => void; className?: string }) {
	return (
		<button
			onClick={onClick}
			className={`flex justify-center py-2.5 bg-white text-black leading-6 tracking-[20%] w-full min-[1000px]:w-39 font-[16px] cursor-pointer ${className ?? ""}`}
		>
			{children}
		</button>
	);
}

export function Landing() {
	const navigate = useNavigate();

	return (
		<div
			className="relative h-dvh w-full flex items-center justify-center p-0 min-[1000px]:p-6"
			style={{ background: "#81818130" }}
		>
			<div className="absolute inset-0 flex items-center justify-center z-0 pointer-events-none">
				<img
					src="/images/Home2.png"
					alt="Home background"
					style={{
						opacity: 0.5,
						width: "calc(100dvw)",
						height: "calc(100dvh)",
						objectFit: "cover",
						objectPosition: "center",
					}}
				/>
			</div>

			{/* Black background with same padding, content above */}
			<div className="flex flex-col items-center justify-center border border-white w-full h-full bg-[#000000] z-10 overflow-auto">
				<div className="w-full h-full flex flex-col items-center justify-center px-4 min-[1000px]:px-0 py-8 min-[1000px]:py-0">
					<div className="text-center flex flex-col items-center justify-center mb-8 min-[1000px]:mb-10">
						<h1
							className="text-[28px] min-[640px]:text-[36px] min-[1000px]:text-[48px] leading-[130%] uppercase font-tomorrow-bold text-center mb-4 min-[1000px]:mb-6 tracking-[12%] min-[1000px]:tracking-[17%] max-w-204.5 text-white"
							data-text="Worem ipsum dolor sit amet, consectetur adipiscing elit."
						>
							Infinite Chat (Eternal Human Chat)
						</h1>
						<p className="text-white leading-[130%] tracking-[15%] min-[1000px]:tracking-[20%] text-[14px] min-[1000px]:text-[16px]">
							Anonymous, ephemeral here-and-now&nbsp; |&nbsp; Chat rooms are born and die&nbsp; |&nbsp; All
							conversations disappear
						</p>
					</div>

					<nav className="flex flex-col gap-3 min-[1000px]:gap-4 items-center w-full max-w-[320px] min-[1000px]:max-w-none">
						<NavBtn onClick={() => navigate("/my-rooms")}>My rooms</NavBtn>
						<NavBtn onClick={() => navigate("/create-room")}>Start a room</NavBtn>
						<NavBtn onClick={() => navigate("/rooms")}>Find a room</NavBtn>
						<NavBtn
							onClick={() => navigate("/about")}
							className="bg-black! text-white! border border-dashed border-white"
						>
							About
						</NavBtn>
					</nav>

					<p className="text-[#ffffff60] leading-[130%] tracking-[15%] min-[1000px]:tracking-[20%] mt-8 min-[1000px]:mt-11 text-[12px] min-[1000px]:text-[16px] text-center">
						Anonymous, ephemeral here-and-now&nbsp; |&nbsp; Chat rooms are born and die&nbsp; |&nbsp; All conversations
						disappear
					</p>
				</div>
			</div>
		</div>
	);
}
